<form [formGroup]="gatewayForm" class="or-form or-form-gateway-details"
      novalidate="novalidate">
  @if (gateway) {
    <div class="or-form-body">
      <div class="or-form-items">

        <!-- Gateway Region Chip -->
        @if (!isNew && gatewayRegion != null) {
          <div class="or-form-item !w-16">
            <mat-chip data-cy="form-gateway-details-region-chip">EU</mat-chip>
          </div>
        } @else {
          <div class="or-form-item !w-16"></div>
        }

        <!-- Health Status -->
        @if (!isNew && gateway) {
          <div class="or-form-item or-form-item-status or-form-gateway-details-keys">
            <app-gateway-health-status
              [gatewayHealth]="gatewayHealth"
              dataCy="form-gateway-details-health">
            </app-gateway-health-status>
          </div>
        }
        <!-- End Health Status -->

        <!-- Gateway Name -->
        <div class="or-form-item or-form-gateway-details-name">
          <input matInput
                 class="or-input"
                 type="text"
                 maxlength="256"
                 formControlName="name"
                 placeholder="Gateway Name"
                 required
                 data-cy="form-gateway-details-name"/>
        </div>

        <!-- Gateway Type -->
        <div class="or-form-item or-form-gateway-details-network-type">
          @if (gatewayForm.get('networkType').value === wirepas.value) {
            <mat-select class="or-select" formControlName="gatewayType"
                        required="required" title="Gateway Version"
                        placeholder="Gateway Type"
                        data-cy="form-gateway-details-gateway-type">
              <mat-option disabled [value]="null">Gateway Type</mat-option>
              @for (gatewayType of getAllGatewayTypes(); track gatewayType.value) {
                <mat-option [value]="gatewayType.value" [attr.data-cy]="'form-gateway-details-gateway-type-option-' + gatewayType.value">{{gatewayType.name}}</mat-option>
              }
            </mat-select>
          }
        </div>

        <!-- Serial Number -->
        <div class="or-form-item or-form-gateway-details-name">
          <input matInput class="or-input" type="text" maxlength="256" formControlName="serialNumber"
                 placeholder="Serial Number" [pattern]="serialNumberPattern" required data-cy="form-gateway-details-serial-number"/>
        </div>

        <!-- Address -->
        <div class="or-form-item or-form-gateway-details-name">
          <input matInput class="or-input" type="text" maxlength="256" formControlName="address"
                 [placeholder]="this.isNew && gatewayForm.get('gatewayType').value !== this.vesta.value ? 'Address will be looked up via Edge Direct' : 'Gateway Address'"
                 [pattern]="pattern" [required]="gatewayForm.get('gatewayType').value === vesta.value"
                 data-cy="form-gateway-details-address"/>
        </div>

        <!-- Edit button -->
        @if (!isNew || gatewayForm.get('networkType').value !== wirepas.value) {
          <div class="or-form-item" [appIsAuthorized]="GlobalAuthority.MANAGE_AWS_CREDENTIALS">
            <button mat-mini-fab class="transparent-button" type="button" (click)="onEdit()"
                    [disabled]="isBusy()"
                    title="View/Edit"
                    matTooltip="View/Edit"
                    matTooltipPosition="above"
                    data-cy="form-gateway-details-view-edit">
              <span class="or-icon or-small or-icon-edit"></span>
            </button>
          </div>
        }
        <!-- Delete button -->
        @if (!isNew && gatewayForm.pristine) {
          <div class="or-form-item">
            <button mat-mini-fab class="or-button or-iconic or-primary or-negative" type="button" (click)="onDelete()"
                    [disabled]="isBusy()"
                    title="Delete gateway"
                    matTooltip="Delete gateway"
                    matTooltipPosition="above"
                    data-cy="form-gateway-details-delete">
              <span class="or-icon or-tiny or-inverse or-icon-trash"></span>
            </button>
          </div>
        }
        <!-- Update button -->
        @if (!isNew && gatewayForm.dirty) {
          <div class="or-form-item or-form-gateway-details-keys">
            <button mat-mini-fab class="or-button or-iconic or-primary or-positive" type="button" (click)="onUpdateGateway()"
                    [disabled]="isBusyOrInvalidOrPristine()"
                    title="Update"
                    matTooltip="Update"
                    matTooltipPosition="above"
                    data-cy="form-gateway-details-update">
              <span class="or-icon or-small or-inverse or-icon-checkmark"></span>
            </button>
          </div>
        }
        <!-- Compare button -->
        @if (!isNew && gatewayForm.get('gatewayType').value !== this.vesta.value) {
          <div class="or-form-item or-form-gateway-details-keys" [appIsAuthorized]="GlobalAuthority.MANAGE_AWS_CREDENTIALS">
            <button mat-mini-fab class="transparent-button" type="button" (click)="onCompareGatewayStates()"
                    [disabled]="gatewayCanBeConfigured()"
                    title="Configure"
                    matTooltip="Configure"
                    matTooltipPosition="above"
                    data-cy="form-gateway-details-compare">
              <span class="or-icon or-small or-inverse or-icon-gateway-config"></span>
            </button>
          </div>
        }
        <!-- Migrate button -->
        @if (!isNew && !gatewayForm.get('hasMatchingBuildingAWSRegion').value ) {
          <div class="or-form-item or-form-gateway-details-keys" [appIsAuthorized]="GlobalAuthority.MANAGE_BUILDINGS">
            <button mat-mini-fab class="transparent-button" type="button"
                    (click)="migrateGateway()"
                    title="Migrate"
                    matTooltip="Migrate"
                    matTooltipPosition="above"
                    data-cy="form-gateway-details-migrate">
              <span class="or-icon or-small or-inverse or-icon-migrate"></span>
            </button>
          </div>
        }

        @if (isNew) {
          <div class="or-form-item">
            <button mat-mini-fab class="or-button or-iconic or-primary or-positive" type="button" (click)="onAddGateway()"
                    [disabled]="isBusyOrInvalidOrPristine()"
                    title="Add gateway"
                    matTooltip="Add gateway"
                    matTooltipPosition="above"
                    data-cy="form-gateway-details-add">
              <span class="or-icon or-small or-inverse or-icon-plus"></span>
            </button>
          </div>
        }
        @if (isNew || (!isNew && gatewayForm.dirty)) {
          <div class="or-form-item">
            <button mat-mini-fab class="transparent-button" type="button" (click)="onResetGateway()"
                    title="Reset changes"
                    matTooltip="Reset changes"
                    matTooltipPosition="above"
                    data-cy="form-gateway-details-reset">
              <span class="or-icon or-small or-icon-reload"></span>
            </button>
          </div>
        }
        <!-- Generate Keys button -->
        @if (!isNew && !hasKeys()) {
          <div class="or-form-item">
            <button mat-mini-fab class="transparent-button" type="button" (click)="onGenerateKeys()"
                    [disabled]="isBusy()"
                    title="Generate Keys"
                    matTooltip="Generate Keys"
                    matTooltipPosition="above"
                    data-cy="form-gateway-details-keys">
              <span class="or-icon or-small or-inverse or-icon-key"></span>
            </button>
          </div>
        }


        @if ((isViewEdit) && (gatewayForm.get('networkType').value === wirepas.value)) {
          <div class="or-form-items" [appIsAuthorized]="GlobalAuthority.MANAGE_AWS_CREDENTIALS">
            <div class="or-form-item or-form-gateway-details-network-type">
              <mat-select class="or-select" formControlName="networkType"
                          required title="Network Type"
                          data-cy="form-gateway-details-network-type">
                <mat-option disabled [value]="null">Network Type</mat-option>
                @for (type of getAllNetworkTypes(); track type.name) {
                  <mat-option [value]="type.value" [attr.data-cy]="'form-gateway-details-network-type-option-' + type.value">{{type.name}}</mat-option>
                }
              </mat-select>
            </div>

            <div class="or-form-item or-form-gateway-details-network-type">
              @if (gatewayForm.get('networkType').value === wirepas.value) {
                <mat-select class="or-select" formControlName="firmwareVersionId"
                        required="required" title="Firmware Version" data-cy="form-gateway-details-firmware-version">
                  <mat-option disabled [value]="null">Firmware Version</mat-option>
                  @for (firmwareVersion of getAllFirmwareVersions(); track firmwareVersion.id) {
                    <mat-option [value]="firmwareVersion.id" [attr.data-cy]="'form-gateway-details-firmware-version-option-' + firmwareVersion.version" >{{firmwareVersion.version}}</mat-option>
                  }
                </mat-select>
              }
            </div>

            @if (gatewayForm.get('networkType').value === wirepas.value){
              <div class="or-form-item">
                <mat-checkbox class="checkbox-color-white" [id]='"default-network-" + gateway.id' formControlName="isDefaultNetwork"
                              (change)='resetNetworkFields()'
                              data-cy="form-gateway-details-default-network"></mat-checkbox>
                <mat-label [id]='"default-network-" + gateway.id' class="or-label or-label-right">Default/Auto Network</mat-label>
              </div>
            }
            @if (gatewayForm.get('networkType').value === wirepas.value && !gatewayForm.get('isDefaultNetwork').value) {
              <div class="or-form-item or-form-gateway-details-ip-address">
                <input matInput class="or-input" type="text" formControlName="staticIpAddress" placeholder="IP Address"
                       [pattern]="ipAddressPattern" [required]="gatewayForm.get('networkType').value === wirepas.value && !gatewayForm.get('isDefaultNetwork').value"
                       data-cy="form-gateway-details-static-ip"/>
              </div>

              <div class="or-form-item or-form-gateway-details-ip-address">
                <input matInput class="or-input" type="text" formControlName="gatewayIpAddress" placeholder="Router IP Address"
                       [pattern]="ipAddressPattern" [required]="gatewayForm.get('networkType').value === wirepas.value && !gatewayForm.get('isDefaultNetwork').value"
                       data-cy="form-gateway-details-gateway-ip"/>
              </div>

              <div class="or-form-item or-form-gateway-details-ip-address">
                <input matInput class="or-input" type="text" formControlName="subnetMask" placeholder="Subnet Mask"
                       [pattern]="ipAddressPattern" [required]="gatewayForm.get('networkType').value === wirepas.value && !gatewayForm.get('isDefaultNetwork').value"
                       data-cy="form-gateway-details-subnet"/>
              </div>

              <div class="or-form-item">
                <mat-checkbox class="checkbox-color-white" [id]='"default-dns-" + gateway.id' formControlName="isDefaultDns"
                              (change)='resetDnsFields()'
                              data-cy="form-gateway-details-default-dns"></mat-checkbox>
                <mat-label [id]='"default-dns-" + gateway.id' class="or-label or-label-right">Default DNS</mat-label>
              </div>
            }

            @if (gatewayForm.get('networkType').value === wirepas.value && !gatewayForm.get('isDefaultNetwork').value && !gatewayForm.get('isDefaultDns').value) {
              <div class="or-form-item or-form-gateway-details-ip-address">
                <input matInput class="or-input" type="text" formControlName="dnsServers" placeholder="DNS Servers"
                       [pattern]="dnsServersPattern"
                       [required]="gatewayForm.get('networkType').value === wirepas.value && !gatewayForm.get('isDefaultNetwork').value && !gatewayForm.get('isDefaultDns').value"
                       data-cy="form-gateway-details-dns-servers"/>
              </div>
            }
          </div>
        }
        @if ((isViewEdit) && (gatewayForm.get('networkType').value === wirepas.value && gatewayForm.get('gatewayType').value !== vesta.value)){
          <div class="or-form-items" [appIsAuthorized]="GlobalAuthority.MANAGE_AWS_CREDENTIALS">
            <div class="or-form-item">
              <mat-checkbox class="checkbox-color-white" [id]='"iot-" + gateway.id' formControlName="isAwsIotEnabled"
                            (change)='updateToDefault(["iotLogLevel"])'
                            data-cy="form-gateway-details-iot-enabled"></mat-checkbox>
              <mat-label [id]='"iot-" + gateway.id' class="or-label or-label-right">IoT</mat-label>
            </div>
            @if (gatewayForm.get('isAwsIotEnabled').value) {
              <div class="or-form-item or-form-gateway-details-log">
                <mat-select class="or-select"
                            formControlName="iotLogLevel"
                            placeholder="IOT Log Level"
                            required data-cy="form-gateway-details-iot-log-level">
                  <mat-option disabled [value]="null">IOT Log Level</mat-option>
                  @for (logLevel of getAllLogLevels(); track logLevel.name) {
                    <mat-option [value]="logLevel.value" [attr.data-cy]="'form-gateway-details-iot-log-level-option-' + logLevel.value">{{logLevel.name}}</mat-option>
                  }
                </mat-select>
              </div>
            }
            <div class="or-form-item">
              <mat-checkbox class="checkbox-color-white" [id]='"otap-" + gateway.id' formControlName="isOtapEnabled"
                            (change)='updateToDefault(["otapLogLevel"])'
                            data-cy="form-gateway-details-otap-enabled"></mat-checkbox>
              <mat-label [id]='"otap-" + gateway.id' class="or-label or-label-right">OTAP</mat-label>
            </div>
            @if (gatewayForm.get('isOtapEnabled').value) {
              <div class="or-form-item or-form-gateway-details-log">
                <mat-select class="or-select"
                            formControlName="otapLogLevel"
                            placeholder="OTAP Log Level"
                            required data-cy="form-gateway-details-otap-log-level">
                  <mat-option disabled [value]="null">OTAP Log Level</mat-option>
                  @for (logLevel of getAllLogLevels(); track logLevel.name) {
                    <mat-option [value]="logLevel.value" [attr.data-cy]="'form-gateway-details-otap-log-level-option-' + logLevel.value">{{logLevel.name}}</mat-option>
                  }
                </mat-select>
              </div>
            }
            <div class="or-form-item">
              <mat-checkbox class="checkbox-color-white" [id]='"wnt-" + gateway.id' formControlName="isWntEnabled"
                            (change)='updateToDefault(["wntLogLevel"])'
                            data-cy="form-gateway-details-wnt-enabled"></mat-checkbox>
              <mat-label [id]='"wnt-" + gateway.id' class="or-label or-label-right">WNT</mat-label>
            </div>
<!--            WNT Log level selection disabled till Gateway Snap issue resolved -->
<!--            @if (gatewayForm.get('isWntEnabled').value) {-->
<!--              <div class="or-form-item or-form-gateway-details-log">-->
<!--                <mat-select class="or-select"-->
<!--                            formControlName="wntLogLevel"-->
<!--                            placeholder="WNT Log Level"-->
<!--                            required data-cy="form-gateway-details-wnt-log-level">-->
<!--                  <mat-option disabled [value]="null">WNT Log Level</mat-option>-->
<!--                  @for (logLevel of getAllLogLevels(); track logLevel.name) {-->
<!--                    <mat-option [value]="logLevel.value" [attr.data-cy]="'form-gateway-details-wnt-log-level-option-' + logLevel.value">{{logLevel.name}}</mat-option>-->
<!--                  }-->
<!--                </mat-select>-->
<!--              </div>-->
<!--            }-->
            <div class="or-form-item">
              <mat-checkbox class="checkbox-color-white" [id]='"bacnet-" + gateway.id' formControlName="isBacnetEnabled"
                            (change)='resetBacnetFields()'
                            data-cy="form-gateway-details-bacnet-enabled"></mat-checkbox>
              <mat-label [id]='"bacnet-" + gateway.id' class="or-label or-label-right">BACnet</mat-label>
            </div>
            @if (gatewayForm.get('isBacnetEnabled').value) {
              <div class="or-form-item or-form-gateway-details-log">
                <mat-select class="or-select"
                            formControlName="bacnetLogLevel"
                            placeholder="BACnet Log Level"
                            required data-cy="form-gateway-details-bacnet-log-level">
                  <mat-option disabled [value]="null">BACnet Log Level</mat-option>
                  @for (logLevel of getAllLogLevels(); track logLevel.name) {
                    <mat-option [value]="logLevel.value" [attr.data-cy]="'form-gateway-details-bacnet-log-level-option-' + logLevel.value">{{logLevel.name}}</mat-option>
                  }
                </mat-select>
              </div>
              <div class="or-form-item">
                <input matInput class="or-input" type="text" formControlName="bacnetDeviceId" placeholder="BACnet Device ID"
                       [required]="gatewayForm.get('networkType').value === wirepas.value" data-cy="form-gateway-details-bacnet-device"/>
              </div>
              <div class="or-form-item">
                <input matInput class="or-input" type="text" formControlName="bacnetPort" placeholder="BACnet Port"
                       [required]="gatewayForm.get('networkType').value === wirepas.value" data-cy="form-gateway-details-bacnet-port"/>
              </div>
            }
          </div>
        }

        @if (isViewEdit) {
          <div class="or-form-items" [appIsAuthorized]="GlobalAuthority.MANAGE_AWS_CREDENTIALS">
            <div class="or-form-item or-form-gateway-details-log">
              <mat-select class="or-select"
                          formControlName="gatewayHealthLogLevel"
                          placeholder="Gateway Health Log Level"
                          required data-cy="form-gateway-details-gw-health-log-level">
                <mat-option disabled [value]="null">Gateway Health Log Level</mat-option>
                @for (logLevel of getAllLogLevels(); track logLevel.name) {
                  <mat-option [value]="logLevel.value" [attr.data-cy]="'form-gateway-details-gateway-health-log-level-option-' + logLevel.value">{{logLevel.name}}</mat-option>
                }
              </mat-select>
            </div>
            <div class="or-form-item or-form-gateway-details-version">
                <mat-select class="or-select" type="number"
                            formControlName="versionNumber"
                            placeholder="Gateway Version"
                            required="required" title="Gateway Version"
                            (selectionChange)="onOptionsSelected($event)"
                            data-cy="form-gateway-details-version-number">
                  <mat-option disabled [value]="null">Gateway Version</mat-option>
                  @for (gatewayVersion of getAllGatewayVersions(); track gatewayVersion.value) {
                    <mat-option [value]="gatewayVersion.value" [attr.data-cy]="'form-gateway-details-version-number-option-' + gatewayVersion.value">{{gatewayVersion.value}}</mat-option>
                  }
                </mat-select>
            </div>
          </div>
        }

        @if (!isNew) {
          <div class="or-form-item" [appIsAuthorized]="GlobalAuthority.VIEW_HIDDEN_COMPONENTS" >
            <button mat-mini-fab class="or-button or-iconic" type="button" (click)="onRestartGateway()" [disabled]="isBusy()"
                    title="Restart gateway" data-cy="form-gateway-details-restart">
              <span class="or-icon or-small or-icon-plug"></span>
            </button>
          </div>
          <div class="or-form-item" [appIsAuthorized]="GlobalAuthority.VIEW_HIDDEN_COMPONENTS">
            <span>Last restart:</span><span name='lastRestart' data-cy="form-gateway-details-last-restart">{{gateway.lastRestart}}</span>
          </div>
        }
      </div>
    </div>
  }
</form>
